const routers = [
  {
    // 外协入库异常
    path: '/outsourceexception/list',
    name: 'outsourceexception',
    component: () => import('@/views/modules/exception/outsourceexception/List.vue')
  },
  {
    // 半成品入库异常
    path: '/halfinstoreexception/list',
    name: 'halfinstoreexception',
    component: () => import('@/views/modules/exception/halfinstoreexception/List.vue')
  }
]
export default routers
